import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js'
import { Link, useNavigate } from 'react-router-dom'
import '../Assets/CSS/EventPage.css';
import ContactUs from '../sections/home/Contactus';
import Login from '../components/auth/login/Login';

const EventPage = ({ isAuthenticated }) => {
    const Navigate = useNavigate();
    const [eventdata, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false); // State for login modal visibility
    const [selectedEvent, setSelectedEvent] = useState(null); // Store selected event details
    useEffect(() => {
        fetchEvents();
    }, []);
    const fetchEvents = async () => {
        setLoading(true); // Start loading
        try {
            // await new Promise(resolve => setTimeout(resolve, 2000));

            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/event/allevents`,
            );
            const data = await response.json();
            setEvents(data);
            console.log(eventdata);
            if (response === 200) {
                console.log(data);
            }
            else {
                showLoginModal(true);
                Navigate('/login');
            }
        }
        catch (error) {
            console.error("Error fetching daily attendance data:", error);
        }
        finally{
            setLoading(false);
        }
    };
    const renderEvent = (event) => (

        <div key={event.eventId} className='col-lg-4 col-md-12 col-sm-12 mb-4'>
            {console.log(event)}

            <div onClick={() => handleEventClick(event.eventId)}
                className="text-decoration-none text-dark">
                <div className="blog-card card" style={{ cursor: 'pointer' }}>
                    <img
                   
                         src={event.eventImage[0]} alt={`blog${event.eventId}`}
                        className="card-img-top eventImage px-2 py-2"
                    />
                    <h1 className='blog-title pt-2' >{event.eventTitle}</h1>
                    <p className='desc'>{event.eventDescription.slice(0, 80)}<span>...</span></p>
                    <small className="text-muted">{new Date(event.createdAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</small>

                </div>
            </div>
        </div>

    );


    const handleEventClick = (eventId) => {
        // Check if the user is authorized
        if (isAuthenticated) {
            // Navigate to the event detail page
            Navigate(`/events/eventdetail/${eventId}`);
        } else {
            // Show login modal
            setSelectedEvent(eventId);
            setShowLoginModal(true);
        }
    };


    const renderSkeletonLoader = () => {
        return Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className='col-lg-4 col-md-12 col-sm-12 mb-4'>
                <div className="blog-card card px-2 py-2" style={{ cursor: 'not-allowed' }}>
                    <div
                        style={{
                            width: '100%',
                            height: '200px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '10px'
                        }}
                    ></div>
                    <div
                        style={{
                            height: '20px',
                            width: '60%',
                            marginTop: '15px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '5px'
                        }}
                    ></div>
                    <div
                        style={{
                            height: '14px',
                            width: '80%',
                            marginTop: '10px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '5px'
                        }}
                    ></div>
                    <div
                        style={{
                            height: '10px',
                            width: '40%',
                            marginTop: '8px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '5px'
                        }}
                    ></div>
                </div>
            </div>
        ));
    };
    
    const handleCloseLogin = () => {
        setShowLoginModal(false);
        setSelectedEvent(null);
    };
    return (
        <div className='common-margin' >
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 bannerimgEvent pb-4 mt-3'>
                        <h1 className='blog-heading p-2 d-flex align-items-center justify-content-start'>

                            <span className='d-flex justify-content-start align-items-center'>
                                <Link to='/' className='text-white text-decoration-none'>
                                    <Icon icon="iconamoon:home-thin" className='fs-4 pb-1 me-1 ' />
                                </Link>
                                <Icon icon="weui:arrow-outlined" className='fs-4  me-1' />
                                <span className='fs-6 me-1'>Events</span>
                            </span>

                        </h1>
                        <h2 className='blog-headingtwo'>Events</h2>
                    </div>
                </div>
                {/* event list  */}
                <div className='container mt-5'>
                    <div className='row'>
                        {/* {eventdata.map((event) => (
                            renderEvent(event)
                        ))} */}
                        {loading ? renderSkeletonLoader() :
                         eventdata.map((event) => renderEvent(event))}

                    </div>

                </div>
            </div>
            <ContactUs />

            {/* Login Modal */}
            {showLoginModal && (<Login onClose={handleCloseLogin} loginopen={showLoginModal} />
            )}

        </div>


    )
}

export default EventPage;

